<template>
  <div class="d-content">
    <dashboard-content-nav :nav="navItems" />
    <keep-alive>
      <component :is="currentComponent" :entity_index="entity_index"></component>
    </keep-alive>
  </div>
</template>
<script>
  import dashboardContentNav from "@/components/dashboard/contentNav.vue";

  //Pages
  import documents from "./documents/documents.vue";
  import offers from "./offers.vue";
  import changeEmpCode from "./changeempcode.vue";
  import empDirectory from "./employeeDirectory.vue";
  import exitOrg from "./exits/exits.vue";
  import perks from "./perks.vue";
  import orgDocuments from "./document.vue";
  import viewOrgTree from "./viewOrgTree.vue"
  import exits from "../payroll/utilities/addexitemployees/addexitemployeesInitial.vue";
  import massCommunication from "../organisation/utilities/massCommunication/communicationconfig.vue";
  // import fbpsettings from "./utilities/fbpsettings/fbpSettings.vue";
  import utilities from "./utilities/utilities.vue";
  import download_payslips from "./utilities/downloadPayslips/downloadPayslips.vue";
  import crudsalarycomponent from "./utilities/salaryComponent/crud_salary_component.vue";
  import editsalarycomponent from "./utilities/salaryComponent/EditSalaryComponent.vue";
  import addNewSalaryComponent from "./utilities/salaryStructure/addNewSalaryComponent.vue";
  import crudRetirementSettings from "./utilities/RetirementSettings/crudRetirementSettings.vue";
  import orgDetails from "./orgDetails/orgDetails.vue";
  import smtp from "./utilities/smtp.vue";
  import voluntaryPf from "./utilities/voluntaryPf.vue";
  import employees from "./employees/employees.vue";
  import addEmployee from "./employees/addEmployee.vue";
  import manageFinancialYear from "./utilities/managefinancialyear/ManageFinancialYear.vue";
  import resetPassword from "./utilities/resetPassword.vue";
  import passwordPolicy from "./utilities/passwordPolicy.vue";

  // SalaryStructure
  import salaryStructure from "./utilities/salaryStructure/salaryStructure.vue";
  import importEmployeeLoans from "./utilities/loans/importEmployeeLoans.vue";
  import loanPaymentSummary from "./utilities/loans/loanPaymentSummary.vue";
  import lta from "./utilities/lta/lta.vue";
// employee exits
import employeeexits from "../payroll/utilities/addexitemployees/addexitemployeesInitial.vue";
import download_bulk_payslips from "./utilities/downloadBulkPayslips";
// import download_bulk_payslips_details from "./utilities/downloadBulkPayslipsdetails";




  const mapNameToComponents = {
    orgDetails: orgDetails,
    documents: documents,
    empDirectory:empDirectory,
    exitOrg: exitOrg,
    perks:perks,
    offers: offers,
    exits:exits,
    orgDocuments:orgDocuments,
    changeEmpCode:changeEmpCode,
    viewOrgTree:viewOrgTree,
    massCommunication:massCommunication,
    // fbpsettings: fbpsettings,
    utilities: utilities,
    smtp: smtp,
    lta: lta,
    download_payslips: download_payslips,
    salarycomponent: crudsalarycomponent,
    editsalarycomponent: editsalarycomponent,
    addsalarycomponent: editsalarycomponent,
    retirementsettings: crudRetirementSettings,
    salarystructure: salaryStructure,
    addNewSalaryComponent: addNewSalaryComponent,
    importEmployeeLoans: importEmployeeLoans,
    loanpaymentsummary: loanPaymentSummary,
    manage_financial_year: manageFinancialYear,
    employeeexits:employeeexits,
    download_bulk_payslips: download_bulk_payslips,
    essManagement: () => import("./utilities/ess/essManagement.vue"),
    essLogin: () => import("./utilities/ess/essLogin.vue"),
    // salarymanagement: () => import("./utilities/salaryComponent/salaryComponent.vue"),
    employees: employees,

    voluntaryPf: voluntaryPf,
    addEmployee: addEmployee,
    events: () => import('./utilities/configureEvents.vue'),
    salarymanagement: () => import("./utilities/salaryComponent/salaryComponent.vue"),
    fnf: () => import('./utilities/fnf/fnf.vue'),
    processfnf: () => import('./utilities/fnf/processfnf.vue'),
    variablecomponents: () => import('./utilities/fnf/variableComponents.vue'),
    ITdeclarations: () => import('./utilities/ITDeclarations/crudITDeclarations.vue'),
    editdeclaration: () => import('./utilities/ITDeclarations/vieworEditDeclaration.vue'),
    editActualdeclaration: () => import('./utilities/ITDeclarations/ActualITDeclarations.vue'),
    dependent: () => import('./utilities/ITDeclarations/dependent.vue'),
    income_tax_lta: () => import('./utilities/ITDeclarations/LTA.vue'),
    telephone_reimbursement: () => import('./utilities/ITDeclarations/TelephoneReimbursement.vue'),
    vehicle_maintenance: () => import('./utilities/ITDeclarations/vehicleMaintenance.vue'),
    driver_salary: () => import('./utilities/ITDeclarations/driverSalary.vue'),
    children_education: () => import('./utilities/ITDeclarations/childrenEducation.vue'),
    relocation: () => import('./utilities/ITDeclarations/relocationAllowence.vue'),
    periodical: () => import('./utilities/ITDeclarations/periodical.vue'),
    importdeclarations: () => import('./utilities/ITDeclarations/importDeclarations.vue'),
    exportdeclarations: () => import('./utilities/ITDeclarations/exportDeclarations.vue'),
    addLeaveInputs: () => import('./utilities/AddLeaveComponent/addLeaveInputs.vue'),
    // salarymanagement: () =>
    // import("./utilities/salaryComponent/salaryComponent.vue"),
    changeemployeemasterfieldsbulk: () =>
      import(
        "./utilities/changeEmployeeMasterFieldsBulk/ChangeEmployeeMasterFieldsBulk.vue"
      ),
    downloaduploadmastertemplate: () =>
      import(
        "./utilities/changeEmployeeMasterFieldsBulk/DownloadUploadMasterTemplate.vue"
      ),
    fbpsettingsandcomponentmapping: () =>
      import("./utilities/fbpcomponentsmapping/FbpComponentsAndSettings.vue"),
    // utilities: utilities,
    // voluntaryPf: voluntaryPf,
    loans: () => import("./utilities/loans/loans.vue"),
    loanMaster: () => import("./utilities/loans/loanMaster.vue"),
    // utilities :utilities,
    form24q: () =>
      import("./utilities/form24Qacknowledgement/form24Qacknowledgement.vue"),
    // employees: employees,
    // voluntaryPf: voluntaryPf,
    // addEmployee: addEmployee,
    // events: () => import("./utilities/configureEvents.vue"),
    form_annexure: () => import('./utilities/formannexure/Form_16Annexure.vue'),
    // form16: () => import("./utilities/form16/form16.vue"),
    assignperk: () => import("./utilities/AssignPerks/perks.vue"),
    newperk: () => import("./utilities/AssignPerks/newperk.vue"),
    loan_details: () => import("./utilities/loanDetails/loanDetails.vue"),
    itremittence: () => import("./utilities/ITRemittence/ITRemittence.vue"),
    resetPassword: resetPassword,
    passwordPolicy: passwordPolicy,
    loanClosure: () =>
      import("./utilities/AssignPerks/loanClosure/loanClosure.vue"),
    policyDocument: () => import("./utilities/policyDocument/policyDocument.vue"),
    documentmaster: () => import("./utilities/documentMaster/documentmaster.vue"),
    legacydata: () => import("./utilities/legacydata/legacyData.vue"),
    masscommconfig: () => import('./utilities/massCommunication/communicationconfig.vue')
  };

  const getPathForStep = (entity_index,step_name, sub_step) => {
    if (sub_step) {
      return `/dashboard/${entity_index}/organisation/${step_name}/${sub_step}`;
    } else {
      return `/dashboard/${entity_index}/organisation/${step_name}`;
    }
  };

  const nav_items = (entity_index) => [ 
    {
      type: "navitem",
      label: "Employee Directory",
      path: getPathForStep(entity_index,"employees"),
      icon: "icon-emp",
      // children: [
      //   {
      //     path: getPathForStep(entity_index,"employees", "addEmployee")
      //   }
      // ]
    },
    {
      type: "navitem",
      label: "Documents",
      path: getPathForStep(entity_index,"documents"),
      icon: "icon-exits"
    },
    // {
    //   type: "navitem",
    //   label: "Perks",
    //   path: getPathForStep(entity_index,"perks"),
    //   icon: "icon-perks"
    // },
    // {
    //   type: "navitem",
    //   label: "Mass communication",
    //   path: getPathForStep(entity_index,"massCommunication"),
    //   icon: "icon-massCommunication"
    // },
    // {
    //   type: "navitem" ,
    //   label: "Change Emp. Code",
    //   path: getPathForStep(entity_index,"changeEmpCode"),
    //   icon:"icon-empcode"
    // },
    {
      type: "navitem",
      label: "View Org Tree",
      path: getPathForStep(entity_index,"viewOrgTree"),
      icon: "icon-orgTree"
    },    
    // {
    //   type: "navitem",
    //   label: "Documents",
    //   path: getPathForStep(entity_index,"orgDocuments"),
    //   icon: "icon-document"
    // },
    // {
    //   type: "navitem",
    //   label: "Offers",
    //   path: getPathForStep(entity_index,"offers"),
    //   icon: "reports"
    // },
    {
      type: "navitem",
      label: "Utilities",
      path: getPathForStep(entity_index,"utilities"),
      icon: "icon-utilities",
      children: [
        {
          path: getPathForStep(entity_index,"utilities", "voluntaryPf")
        },
        {
          path: getPathForStep(entity_index,"utilities", "smtp")
        },
        {
          path: getPathForStep(entity_index,"utilities", "manage_financial_year")
        },
        {
          path: getPathForStep(entity_index,"utilities", "download_payslips")
        },
        {
          path: getPathForStep(entity_index,"utilities", "salarycomponent")
        },
        {
          path: getPathForStep(entity_index,"utilities", "editsalarycomponent")
        },
        {
          path: getPathForStep(entity_index,"utilities", "addsalarycomponent")
        },
        {
          path: getPathForStep(entity_index,"utilities", "essLogin")
        },
        {
          path: getPathForStep(entity_index,"utilities", "retirementsettings")
        },
        {
          path: getPathForStep(entity_index,'utilities', 'ITdeclarations')
        },
        {
          path: getPathForStep(entity_index,'utilities', 'editdeclaration')
        },
        {
          path: getPathForStep(entity_index,'utilities', 'importdeclarations')
        },
        {
          path: getPathForStep(entity_index,'utilities', 'exportdeclarations')
        },
        {
          path: getPathForStep(entity_index,"utilities", "addLeaveInputs")
        },
        {
          path: getPathForStep(entity_index,"utilities", "changeemployeemasterfieldsbulk")
        },
        {
          path: getPathForStep(entity_index,"utilities", "downloaduploadmastertemplate")
        },
        {
          path: getPathForStep(entity_index,"utilities", "form24q")
        },
        {
          path: getPathForStep(entity_index,"utilities", "form16")
        },
        {
          path: getPathForStep(entity_index,"utilities", "resetPassword")
        },
        {
          path: getPathForStep(entity_index,"utilities", "loan_details")
        },
        {
          path: getPathForStep(entity_index,"utilities", "passwordPolicy")
        },
        {
          path: getPathForStep(entity_index,"utilities", "loanpaymentsummary")
        },
        {
          path: getPathForStep(entity_index,"utilities", "changeemployeemasterfieldsbulk")
        },
        {
          path: getPathForStep(entity_index,"utilities", "downloaduploadmastertemplate")
        },
        {
          path: getPathForStep(entity_index,"utilities", "fbpsettingsandcomponentmapping")
        },
        {
          path: getPathForStep(entity_index,"utilities", "legacydata")
        },
        {
          path: getPathForStep(entity_index,"utilities", "form_annexure")
        },
        /*
        {
          path: getPathForStep("utilities", "assignperk"),
          children: [
            {
              path: getPathForStep('utilities','voluntaryPf'),
            },
            {
              path: getPathForStep('utilities', 'smtp')
            },
            {
              path: getPathForStep("utilities", "download_payslips")
            },
            {
              path: getPathForStep("utilities", "salarycomponent")
            },
            {
              path: getPathForStep("utilities", "editsalarycomponent")
            },
            {
              path: getPathForStep("utilities", "essLogin")
            },
            {
              path: getPathForStep("utilities", "retirementsettings")
            },
            {
              path: getPathForStep("utilities", "fbpsettings")
            },
            {
              path: getPathForStep("utilities", "fnf")
            },
            {
              path: getPathForStep("utilities", "processfnf")
            }
          ]
        {
          path: getPathForStep("utilities", "policyDocument")
        }
        */
      ]
    }
  ];

  export default {
    components: {
      dashboardContentNav
    },
    props: ["step_name", "sub_step", "sub_step_name",'entity_index'],
    data() {
      return {
        navItems: []
      };
    },
    mounted() {
      this.updateNavItems()
    },
    methods: {
      contentShow(event) {
        var sections = document.querySelectorAll(".d-payroll__accordBlock");
        for (let i = 0; i < sections.length; i++) {
          sections[i].classList.remove("active");
        }
        event.target.parentNode.classList.toggle("active");
      },
      updateNavItems() {
        if (this.ifHr || this.ifEmployee) {
        // this.navItems.unshift();
        this.navItems.splice(0,3);
        this.navItems.splice(2,1);
        }  else if(this.ifAuditor) {
          this.navItems = [];
        }
        else {
          return this.navItems;
        }
        
      }
    },
    created() {
      this.navItems = nav_items(this.entity_index);
    },
    computed: {
      currentComponent: function () {
        if (this.sub_step_name) {
          return mapNameToComponents[this.sub_step_name];
        } else {
          return mapNameToComponents[this.sub_step];
        }
      },
      ifHr() {
        return localStorage.getItem("userRole") == "HR" ? true : false;
      },
      ifEmployee() {
        return localStorage.getItem("userRole") == "EMPLOYEE" ? true : false;
      },
      ifAuditor() {
      return localStorage.getItem("userRole") == "AUDITOR" ? true : false;
     }
    }
  };
</script>
<style lang="scss" scoped>
  @import "@/scss/dashboard/_variables.scss"; // Common
  @import "@/scss/dashboard/content/_section.scss"; // Content Section
</style>